import React, { useState } from 'react'
import {
    Table,
    TableBody,
    TableCaption,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
  } from "@/components/ui/table"
import { Spinner } from '@/components/ui/shadcn-io/spinner';
import Helper from '@/lib/helper';

const PaymentHistory = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [paymentHistory, setPaymentHistory] = useState<any>([]);
    
    return (
        <div>
            <h5 className='h5 uppercase'>Payment History</h5>
            <div className='mt-5'>
                <Table className='mt-5'>
                    <TableHeader>
                        <TableRow>
                        <TableHead>No</TableHead>
                        <TableHead>Items</TableHead>
                        <TableHead>Amount</TableHead>
                        <TableHead>Date</TableHead>
                        <TableHead>Receipt</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                    {
                        loading ? (
                            <TableRow>
                                <TableCell colSpan={4}>
                                    <div className='flex justify-center py-4'>
                                        <Spinner />
                                    </div>
                                </TableCell>
                            </TableRow>
                        ) 
                        : 
                        paymentHistory && paymentHistory.length > 0 ? (
                            paymentHistory.map((history, index) => (
                                <TableRow key={history.id}>
                                    <TableCell>
                                        <div className='flex'>
                                            <div 
                                            className='rounded-lg'
                                            style={{ 
                                                height: 100,
                                                width: 100,
                                                background: `url(${
                                                import.meta.env.VITE_AWS_S3}/${(history.medias.find(x => x.mediaType === 1 && x.isCover === 1)?.path ||
                                                    history.medias.find(x => x.mediaType === 1)?.path)})`,
                                                backgroundSize: 'cover',
                                                backgroundPosition: 'center center'
                                            }}/>
                                            <div className='px-3'>
                                                <div>{history.headline}</div>
                                                <div className='text-xs mt-1'>{history.rawAddress}</div>
                                                <div className='font-bold mt-2'>{Helper.formatCurrency(Number(history.price))}</div>
                                            </div>
                                        </div>
                                    </TableCell>
                                    <TableCell>
                                    </TableCell>
                                    <TableCell>
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : 
                        (
                            <TableRow>
                                <TableCell colSpan={5} className="text-center py-4">
                                    You have no payment history.
                                </TableCell>
                            </TableRow>
                        )
                    }
                    </TableBody>
                </Table>
            </div>
        </div>
    )
}

export default PaymentHistory